export const SET_EMAIL = 'SET_EMAIL';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_NEW_PASSWORD = 'SET_NEW_PASSWORD';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_LOGIN_INFO = 'CLEAR_LOGIN_INFO';